<template>
  <div class="auto-currency">
    <a
      :href="priceSortLink"
      :class="'auto-currency__list-button ' + order"
    >
      цена <svg
        width="7"
        height="10"
      ><use xlink:href="assets/app/svg/sprite.svg#sort-inactive" /></svg>
    </a>

    <div class="auto-currency__list-container">
      <button
        class="auto-currency__button"
        @click="containerOpened = !containerOpened"
      >
        {{ currency }} <svg
          width="8"
          height="12"
        ><use xlink:href="assets/app/svg/sprite.svg#arrows" /></svg>
      </button>

      <div
        v-show="containerOpened"
        class="auto-currency__container"
      >
        <button
          v-for="curr in currencies"
          :key="curr"
          class="auto-currency__container-item"
          :class="{active: curr === currency}"
          @click="() => changeCurrency(curr)"
        >
          {{ curr }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutoCurrency',
  props: {
    priceSortLink: {
      type: String,
      required: true,
    },
    order: {
      type: String,
      required: true,
    },
    currencyLink: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      containerOpened: false,
      currency: 'RUB',
      currencies: ['RUB', 'USD', 'EUR'],
    }
  },
  mounted() {
    document.addEventListener('click', e => {
      const component = e.path.find(el => {
        return el.id === 'vueAutoCurrency'
      })

      if (!component) this.containerOpened = false
    })
  },
  methods: {
    changeCurrency(currency) {
      this.currency = currency
      this.containerOpened = false
      fetch('/index.php?route=currency/currency&currency=' + currency)
        .then(response => {
          if (response.ok) {
            return response.json()
          }
        })
        .then(json => {
          if (json.success) {
            location.reload()
          } else {
            console.error(json.error)
          }
        })
    }
  },
}
</script>

<style lang="scss">
.auto-currency {
  display: flex;
  align-items: flex-start;

  &__list-container {
    position: relative;
  }

  &__button {
    display: flex;
    align-items: center;
    padding: 4px 3px 3px;
    color: #414446;
    font-weight: 300;
    font-size: 13px;
    background-color: transparent;
    border: none;
    border-radius: 3px;

    svg {
      margin-left: 4px;
    }

    &:focus {
      box-shadow: 0 0 5px rgba(0,0,0,0.2);
    }
  }

  &__list-button {
    position: relative;
    margin-right: 10px;
    padding: 0 17px 0 0;
    color: #a8acaf;
    font-weight: 300;
    font-size: 16px;
    background-color: transparent;
    border: none;

    svg {
      position: absolute;
      right: 0;
      bottom: 0;
    }

    &.DESC svg {
      transform: scaleY(-1);
    }
  }

  &__container {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 10;
    background-color: #fff;
    border: 1px solid #db1c26;
  }

  &__container-item {
    margin: 0;
    padding: 10px;
    color: #333;
    font-weight: 300;
    background-color: transparent;
    border: none;
    cursor: default;

    &:hover {
      background: #f7f7f7;
    }

    &.active {
      font-weight: 400;
    }
  }
}
</style>
